import { isStale } from '../../lib/visitorsEngagement'
import { todayEastern } from '../../lib/visitorsRange'

/** "Scores from <day>", flagged when the nightly job is more than two days behind. */
export function ScoreDayNote({ scoreDay }: { scoreDay: string | null }) {
  if (!scoreDay) return <p className="font-mono text-[11px] text-paper-faint">No scores computed yet</p>
  const stale = isStale(scoreDay, todayEastern())
  return (
    <p className={`font-mono text-[11px] ${stale ? 'text-radar-red' : 'text-paper-faint'}`}>
      Scores from {scoreDay}{stale ? ' — stale: the nightly score job is behind' : ''}
    </p>
  )
}

